import { render, staticRenderFns } from "./HeaderDropdowns.vue?vue&type=template&id=0bcb4c1e&scoped=true&"
import script from "./HeaderDropdowns.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdowns.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDropdowns.vue?vue&type=style&index=0&id=0bcb4c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb4c1e",
  null
  
)

export default component.exports